import { useState } from "react";
import { Link } from "react-router-dom";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import SEO from "@/components/SEO";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function CustomerRegister() {
  const { register } = useCustomerAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null); // {verify_url?}
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(form.name, form.email, form.password);
    setLoading(false);
    if (res.ok) {
      const verify_url = res.verify_token
        ? `${window.location.origin}/email-bestaetigen?token=${res.verify_token}`
        : null;
      setDone({ ...res, verify_url });
    } else setError(res.error);
  };

  return (
    <div className="on-dark violet-canvas flex-1 w-full flex items-center justify-center px-5 py-20">
      <SEO title="Registrieren" description="Erstelle ein Konto bei GYSUMO." />
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Logo variant="butterfly" className="h-14 w-auto mx-auto mb-4" />
          <h1 className="font-serif text-4xl font-light text-[#FFF9F2]">Registrieren</h1>
        </div>
        {done ? (
          <div className="bg-[#FFF9F2] rounded-md p-7 text-center" data-testid="register-success">
            <h2 className="font-serif text-2xl mb-3">Fast geschafft!</h2>
            <p className="text-[#3A1E55] leading-relaxed">
              Wir haben dir eine E-Mail zur Bestätigung geschickt. Bitte klicke auf den Link darin, um dein Konto zu aktivieren.
            </p>
            {done.verify_url ? (
              <p className="mt-4 text-sm text-[#6E5A82]">
                (Vorschau-Modus ohne E-Mail-Versand)<br />
                <a href={done.verify_url} data-testid="preview-verify-link" className="text-[#632A8E] underline break-all">Konto jetzt bestätigen</a>
              </p>
            ) : null}
            <Link to="/anmelden" className="mt-6 inline-block text-[#632A8E] underline">Zur Anmeldung</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5 bg-[#FFF9F2] rounded-md p-7" data-testid="customer-register-form">
            <div>
              <Label htmlFor="cr-name">Name</Label>
              <Input id="cr-name" data-testid="register-name" required value={form.name} onChange={upd("name")} className="mt-1.5 bg-white" />
            </div>
            <div>
              <Label htmlFor="cr-email">E-Mail</Label>
              <Input id="cr-email" data-testid="register-email" type="email" required value={form.email} onChange={upd("email")} className="mt-1.5 bg-white" />
            </div>
            <div>
              <Label htmlFor="cr-pw">Passwort (mind. 6 Zeichen)</Label>
              <Input id="cr-pw" data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={upd("password")} className="mt-1.5 bg-white" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="register-error">{error}</p>}
            <Button type="submit" data-testid="register-submit" disabled={loading} className="w-full bg-[#F4C542] text-[#32104F] hover:bg-[#D85CA4] rounded-md h-12">
              {loading ? "Konto wird erstellt…" : "Konto erstellen"}
            </Button>
            <p className="text-sm text-center text-[#6E5A82]">
              Bereits registriert? <Link to="/anmelden" data-testid="link-login" className="text-[#632A8E] underline">Anmelden</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
